import { render } from "./ConfirmButton.vue?vue&type=template&id=4d379056&scoped=true"
import script from "./ConfirmButton.vue?vue&type=script&lang=js"
export * from "./ConfirmButton.vue?vue&type=script&lang=js"

import "./ConfirmButton.vue?vue&type=style&index=0&id=4d379056&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4d379056"

export default script